import React from 'react';
import WarningModal from 'components/WarningModal/WarningModal';
import {useHideCampaignForAllUsersMutation} from 'store/slices/campaignSlice';
import {CampaignDto} from 'store/models/campaign';

interface Props {
  open: boolean;
  onClose: () => void;
  campaign: CampaignDto | null;
  onSuccess: (msg: string) => void;
}

export default function HideCampaignModal({
  open,
  onClose,
  campaign,
  onSuccess,
}: Props) {
  const [hideCampaign, {isLoading}] = useHideCampaignForAllUsersMutation();

  if (!open || !campaign) return null;

  const confirm = async () => {
    await hideCampaign({id: campaign.id}).unwrap();
    onSuccess('Campaign hidden.');
    onClose();
  };

  return (
    <WarningModal
      isOpen={open}
      onClose={onClose}
      title="Hide campaign?"
      entityText={campaign.name}
      textBlocks={[`Are you sure you want to hide "${campaign.name}"?`]}
      confirmButtonText="Yes, hide"
      onConfirmButtonClick={confirm}
      loading={isLoading}
    />
  );
}
